import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';
/**
 * Variable generica para gestionar el objeto window de javascript
 */
declare let window: any;

/**
 * Componente del footer
 */
@Component({
  standalone: false,
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  /**
   * Input para el color de los elementos del footer
   */
  @Input() colorItems: string;
  /**
   * Input para la clase css del footer
   */
  @Input() classSpecial: boolean;
  /**
   * Guarda el año a mostrar
   */
  year: number;
  country: string;

  /**
   * Crea una instancia para footer component.
   * @param r 
   * @param c 
   */
  constructor(private r: Router, private c: CommonsService) { }

  /**
   * on init - inicializa el año actual
   */
  ngOnInit() {
    this.year = new Date().getFullYear();
  }

  /**
   * Va a la url dependiendo de lo guardado en el storage
   * @param routing 
   */
  goToUrl(routing) {
    // this.language = sessionStorage.getItem('language');
    this.country = sessionStorage.getItem('country') || 'ES';
    this.c.setCurrentUrl('/' + routing);
    if (routing === 'terms-conditions') {
      sessionStorage.setItem('terms', '1');
      routing = (this.country) + '/' + 'terms-conditions';
    } else if (routing === 'privacy-polity') {
      sessionStorage.setItem('polity', '1');
      routing = (this.country) + '/' + 'privacy-polity';
    }
    this.r.navigateByUrl(routing);
  }

  /**
   * Mostrar banner
   */
  OptanonWrapper() {
    this.c.getBanner();
    window.dataLayer.push({ event: 'OneTrustGroupsUpdated' });
  }
}
